import React, { useState } from 'react';
import { LightBox } from 'react-lightbox-pack';
import './ReactLightboxPack.sass';
import Slider from 'react-slick';
import { constructDevSrc } from '../../utils/helpers';
import Picture from '../Picture';
import './ImageSlider.sass';

interface Props {
	photos: ISliderImage[];
}

interface ImageProps {
	src: string;
	focalPoint: {
		left: string;
		top: string;
	};
	crops: {
		alias: string;
		coordinates: null | { x1: string; y1: string; x2: string; y2: string };
		width: number;
		height: number;
	}[];
}

interface ISliderImage {
	picture: ImageProps;
	fullImage: ImageProps;
}

function ImageSlider(props: Props) {
	const [toggle, setToggle] = useState(false);
	const [sIndex, setSIndex] = useState(0);

	const lightBoxHandler = (state: boolean, index: number) => {
		setToggle(state);
		setSIndex(index);
	};

	const settings = {
		dots: true,
		dotsClass: 'slick-dots image-slider__ctrls',
		arrows: false,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		swipe: false,
	};

	const data = props?.photos?.map((item: ISliderImage, ind: number) => ({
		id: ind + 1,
		image: constructDevSrc(item?.fullImage?.src)
	}));

	return (
		<>
			<div className="image-slider">
				<Slider {...settings} className="image-slider__carouse">
					{props.photos.map((photo, index) => (
						<div
							// eslint-disable-next-line react/no-array-index-key
							key={index}
							onClick={() => lightBoxHandler(true, index)}
							role="button"
							tabIndex={0}
							aria-label="button"
							aria-hidden="true"
						>
							<Picture
								className="image-slider__image"
								imageObj={photo.picture}
							/>
						</div>
					))}
				</Slider>

				<LightBox
					state={toggle}
					event={lightBoxHandler}
					data={data}
					imageWidth="auto"
					imageHeight="80vh"
					thumbnailHeight={0}
					thumbnailWidth={0}
					setImageIndex={setSIndex}
					imageIndex={sIndex}
				/>
			</div>
		</>
	);
}

export default ImageSlider;
